var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 12,
    height: 11,
    rx: 2.5,
    stroke: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 13,
    height: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7204 2.97445C13.7063 2.69867 13.4713 2.48655 13.1955 2.50066L8.70135 2.73066C8.42557 2.74477 8.21345 2.97978 8.22756 3.25556C8.24168 3.53134 8.47668 3.74346 8.75246 3.72935L12.7472 3.52491L12.9517 7.51968C12.9658 7.79546 13.2008 8.00759 13.4766 7.99347C13.7524 7.97936 13.9645 7.74435 13.9504 7.46857L13.7204 2.97445ZM6.37116 11.335L13.5922 3.33503L12.8499 2.66499L5.62884 10.665L6.37116 11.335Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportLogo);
export default __webpack_public_path__ + "static/media/ExportLogo.829d0a6bf4f2a80267b32a63a06a7b87.svg";
export { ForwardRef as ReactComponent };